export default {
  formField: {
    optional: "Optional",
  },
  datePicker: {
    placeholder: "DD/MM/YYYY",
    openCalendar: "Open calendar",
    closeCalendar: "Close calendar",
  },
  comboBox: {
    noResults: "No results",
    clearSelection: "Clear selection",
  },
  input: {
    clearField: "Clear field",
  },
  select: {
    noResults: "No results",
    clearSelection: "Clear selection",
  },
  emptyState: {
    illustrationAlt: "No data illustration",
  },
  avatar: {
    imageAlt: "Avatar",
  },
  avatarStack: {
    loadingAriaLabel: "Loading avatar group",
    groupAriaLabel: "Avatar group with {{count}} people: {{names}}",
    overflowAriaLabel: "{{count}} more people: {{names}}",
    overflowAriaLabelNoNames: "{{count}} more people",
  },
  tag: {
    remove: "Remove",
  },
  pagination: {
    show: "Show",
    pagination: "Pagination",
    goToPrevPage: "Go to previous page",
    goToNextPage: "Go to next page",
    goToPage: "Go to page {{pageNumber}}",
    itemsPerPage: "Items per page",
    itemsRange: "{{from}}-{{to}} of {{total}}",
    ellipsis: "...",
  },
  tabs: {
    moreTabs: "More tabs",
  },
  table: {
    selectionSummary: "Selected {{count}} of {{total}} rows",
    selectionSummaryAll: "Selected all {{total}} rows",
    selectAllButton: "Select all {{total}} rows",
    selectAllItemsOnPageAriaLabel: "Select all items on current page",
    selectRowAriaLabel: "Select row",
    dataTableAriaLabel: "Data table",
    clickableRowAriaLabel: "Clickable row, press Enter or Space to select",
    sortColumnAriaLabel: "Sort by {{column}}",
    sortColumnAscAriaLabel:
      "Sort by {{column}} ascending, press Enter or Space to sort descending",
    sortColumnDescAriaLabel:
      "Sort by {{column}} descending, press Enter or Space to remove sorting",
  },
  columnsSelect: {
    selectColumns: "Select columns",
  },
  drawer: {
    closeLabel: "Close",
  },
  panel: {
    closeLabel: "Close",
  },
  modal: {
    closeLabel: "Close",
  },
  toast: {
    closeNotification: "Close notification",
  },
  copyButton: {
    copy: "Copy",
    copied: "Copied",
  },
  confirmDialog: {
    cancel: "Cancel",
  },
  codeInput: {
    inputGroupAriaLabel: "Verification code, {{length}} digits",
    digitInputAriaLabel: "Digit {{index}} of {{length}}",
  },
  splitButton: {
    openMenu: "Open menu",
  },
  stepper: {
    progress: "Progress",
    stepAriaLabel: "Step {{stepNumber}}: {{stepTitle}}",
  },
};
